import { Card, Col, DatePicker, Form, InputNumber, Row } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { TbCurrencyDollar } from "react-icons/tb";
import { toast } from "react-hot-toast";
import FormAction from "../../../../components/common/FormAction";

function Financials({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const status = {
      "financials.nsfFee": values.nsfFee,
      "financials.eligibleForRentIncreaseOn": values.rentIncreaseOn
        ? values.rentIncreaseOn.format("YYYY-MM-DD")
        : data?.financials?.eligibleForRentIncreaseOn,
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Tenant financials updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    nsfFee: data?.emergencyContact?.nsfFee,
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Financials"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                  labelWrap={{ span: 8 }}
                  initialValues={initialValues}
                  onFinish={handleFormSubmit}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item label="Deposit Paid">
                    <span>
                      {data?.financials?.depositPaid
                        ? data?.financials?.depositPaid
                        : "--"}
                    </span>
                  </Form.Item>
                  <Form.Item label="Utility Billing (RUBS) Enabled">
                    <span className="onclick-text">
                      {" "}
                      {data?.financials?.utilityBillsEnabled
                        ? data?.financials?.utilityBillsEnabled
                        : "--"}
                    </span>
                  </Form.Item>
                  <Form.Item label="NSF Fee" name="nsfFee">
                    <InputNumber
                      style={{ width: "60%" }}
                      addonBefore={<TbCurrencyDollar size={16} />}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Eligible For Rent Increase On"
                    name="rentIncreaseOn"
                  >
                    <DatePicker style={{ width: "60%" }} />
                  </Form.Item>
                  <FormAction submit="submit" cancel={onCancel} />
                </Form>
              </Col>
            </Row>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Deposit Paid">
                <span>
                  {data?.financials?.depositPaid
                    ? data?.financials?.depositPaid
                    : "--"}
                </span>
              </Form.Item>
              <Form.Item label="Utility Billing (RUBS) Enabled">
                <span className="onclick-text">
                  {data?.financials?.utilityBillsEnabled
                    ? data?.financials?.utilityBillsEnabled
                    : "--"}
                </span>
              </Form.Item>
              <Form.Item label="NSF Fee">
                <span>
                  $ {data?.financials?.nsfFee ? data?.financials?.nsfFee : "--"}
                </span>
              </Form.Item>
              <Form.Item label="Eligible For Rent Increase On">
                <span>
                  {data?.financials?.eligibleForRentIncreaseOn
                    ? data?.financials?.eligibleForRentIncreaseOn
                    : "--"}
                </span>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Financials;
